import React from 'react';
import cesar from '../../assets/image/portafolio/cesar.webp';
import cvPdf from '../../assets/cv_cesar_fuentes.pdf';
import { motion } from 'framer-motion';

const AboutMe = () => {
    return (
        <section id="about" className="py-24 relative overflow-hidden">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-accent-cyan font-medium tracking-widest text-sm uppercase mb-3 block">
                        Conóceme
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-6">
                        Acerca de Mí
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple mx-auto rounded-full"></div>
                </motion.div>

                <div className="flex flex-col lg:flex-row items-center gap-16">
                    {/* Image */}
                    <motion.div 
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="w-full lg:w-1/2"
                    >
                        <div className="relative max-w-md mx-auto lg:mx-0">
                            <div className="absolute inset-0 bg-gradient-to-tr from-accent-purple/20 to-accent-cyan/20 rounded-3xl transform rotate-3 scale-105 -z-10"></div>
                            <div className="glass-card p-2 rounded-3xl bg-dark-800/50">
                                <img 
                                    src={cesar} 
                                    alt="Cesar Fuentes" 
                                    className="w-full h-auto rounded-2xl object-cover shadow-2xl"
                                />
                            </div>
                        </div>
                    </motion.div>

                    {/* Content */}
                    <motion.div 
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="w-full lg:w-1/2"
                    >
                        <h3 className="text-3xl font-display font-bold text-white mb-2">¡Hola! Soy Cesar Fuentes</h3>
                        <h4 className="text-xl text-accent-cyan mb-6">Ingeniero en Sistemas</h4>
                        
                        <p className="text-slate-400 mb-8 leading-relaxed">
                            Soy Ingeniero en Sistemas especializado en desarrollo web, e-commerce y soluciones digitales a medida.
                            Mi enfoque se centra en crear plataformas eficientes, seguras y escalables que respondan a las 
                            necesidades reales de cada cliente. Tengo experiencia en el diseño y desarrollo de sitios web 
                            personalizados y tiendas en línea, optimizadas para ofrecer una excelente experiencia de 
                            usuario y maximizar el rendimiento del negocio.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                            {[
                                { label: 'Cumpleaños', value: 'Mayo 12, 1994' },
                                { label: 'Celular', value: '+591 73643349' },
                                { label: 'Correo', value: 'cesarfuentes0594@gmail.com' },
                                { label: 'Nacionalidad', value: 'Boliviana' },
                                { label: 'Lenguaje', value: 'Español' },
                                { label: 'Freelance', value: 'Disponible', highlight: true },
                            ].map((info, idx) => (
                                <div key={idx} className="flex items-center gap-2">
                                    <span className="text-slate-500 min-w[100px]">{info.label}:</span>
                                    <span className={`font-medium ${info.highlight ? 'text-accent-cyan' : 'text-slate-200'}`}>
                                        {info.value}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <motion.a 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href={cvPdf} 
                            download="CV_Cesar_Fuentes.pdf" 
                            className="btn-primary inline-block text-center"
                        >
                            Descargar CV
                        </motion.a>
                    </motion.div>
                </div>
            </div>
            {/* Background elements */}
            <div className="absolute top-1/2 right-0 w-64 h-64 bg-accent-purple/5 rounded-full blur-[80px] -z-10 transform -translate-y-1/2"></div>
        </section>
    );
};

export default AboutMe;